import { ResourceType } from './ResourceHelper';
export default class ProductHelper {
    static resolveSectionData(sectionsToUpdate) {
        sectionsToUpdate.forEach((chapter) => {
            chapter.hasDemos = false;
            chapter.hasExams = false;
            chapter.hasSims = false;
            chapter.hasTextLessons = false;
            chapter.hasVideos = false;
            if (chapter.children) {
                chapter.children.forEach((section) => {
                    section.hasDemos = false;
                    section.hasExams = false;
                    section.hasSims = false;
                    section.hasTextLessons = false;
                    section.hasVideos = false;
                    section.chapter = chapter;
                    section.section = section;
                    if (section.children) {
                        section.children.forEach((resource) => {
                            resource.section = section;
                            resource.chapter = chapter;
                            switch (resource.type) {
                                case ResourceType.DEMO:
                                    section.hasDemos = true;
                                    break;
                                case ResourceType.SIMULATION:
                                    section.hasSims = true;
                                    break;
                                case ResourceType.TEXT_LESSON:
                                    section.hasTextLessons = true;
                                    break;
                                case ResourceType.VIDEO:
                                    section.hasVideos = true;
                                    break;
                                case ResourceType.EXAM:
                                case '':
                                case null:
                                default:
                                    resource.type = ResourceType.EXAM;
                                    section.hasExams = true;
                                    break;
                            }
                        });
                    }
                });
            }
        });
        return sectionsToUpdate;
    }
}
//# sourceMappingURL=ProductHelper.js.map